/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UndoService } from '../undo.service';
import { DraggableContainerComponent } from 'src/app/common/utility-components/draggable-container/draggable-container.component';
import * as AppStrings from '@touchplan/strings';
import { ContainerType } from '../../utility-components/base-container/ContainerLayerManager';

@Component({
	selector: 'undo-panel',
	templateUrl: './undo-panel.component.html',
	styleUrls: ['./undo-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UndoPanelComponent {
	@ViewChild('dragContainer', { static: false }) public dragContainer: DraggableContainerComponent;

	public list$ = this.undoService.list$;
	public selectedIndex$ = this.undoService.index$;
	public showUndo$ = new BehaviorSubject(false);
	public lock$: Observable<boolean>;
	public listSize$: Observable<number>;
	public AppStrings = AppStrings;
	public containerType = ContainerType.UndoPanel;

	constructor(private undoService: UndoService) {
		this.lock$ = undoService.applyInProgres$;
		this.listSize$ = this.list$.pipe(map((list) => list.length));
	}

	public applyUndo(idx: number) {
		this.undoService.applyUndo(idx);
	}

	public togglePanel() {
		const isShowing = this.showUndo$.getValue();
		this.showUndo$.next(!isShowing);

		if (!isShowing) {
			setTimeout(() => this.dragContainer.snapToRightEdge(), 0);
		}
	}
}
